import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css/normalize.css'
import '@/styles/index.scss'

import { MyPlugin } from '@/plugins/mixins.js'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/element-variables.scss'
import locale from 'element-ui/lib/locale/lang/zh-CN'
Vue.config.productionTip = false
Vue.use(MyPlugin) // lang i18n
Vue.use(ElementUI, {
  locale
})
const env = process.env.NODE_ENV
router.beforeEach(async (to, from, next) => {
  if (env === 'production') {
    window._hmt && window._hmt.push(['_trackPageview', '/#' + to.fullPath])
  }
  next()
})

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
